/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddCarveOutQuoteRequest
 */
export interface AddCarveOutQuoteRequest {
    /**
     * 
     */
    s3_key: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    content_type?: string;
}

/**
 * Check if a given object implements the AddCarveOutQuoteRequest interface.
 */
export function instanceOfAddCarveOutQuoteRequest(value: object): value is AddCarveOutQuoteRequest {
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AddCarveOutQuoteRequestFromJSON(json: any): AddCarveOutQuoteRequest {
    return AddCarveOutQuoteRequestFromJSONTyped(json, false);
}

export function AddCarveOutQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCarveOutQuoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        's3_key': json['s3_key'],
        'name': json['name'],
        'content_type': json['content_type'] == null ? undefined : json['content_type'],
    };
}

export function AddCarveOutQuoteRequestToJSON(json: any): AddCarveOutQuoteRequest {
    return AddCarveOutQuoteRequestToJSONTyped(json, false);
}

export function AddCarveOutQuoteRequestToJSONTyped(value?: AddCarveOutQuoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        's3_key': value['s3_key'],
        'name': value['name'],
        'content_type': value['content_type'],
    };
}

